/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import OutlinedDown from 'acud-icon/lib/icons/OutlinedDown';
import Button from '../button';
import { ConfigContext } from '../config-provider';
import Dropdown from './dropdown';
const ButtonGroup = Button.Group;
const DropdownButton = props => {
    const { children, overlay, disabled, trigger, visible, placement = 'bottomRight', prefixCls: customizePrefixCls, onClick, onVisibleChange, overlayClassName, overlayStyle, getPopupContainer } = props, restProps = __rest(props, ["children", "overlay", "disabled", "trigger", "visible", "placement", "prefixCls", "onClick", "onVisibleChange", "overlayClassName", "overlayStyle", "getPopupContainer"]);
    // 菜单可见，需要将ICON旋转
    const [popupVisible, setPopupVisible] = useState(!!visible);
    const mergedVisible = 'visible' in props ? visible : popupVisible;
    const handleVisibleChange = useCallback((visible) => {
        if (!('visible' in props)) {
            setPopupVisible(visible);
        }
        onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(visible);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const arrowCls = classNames({
        [`${prefixCls}-expand`]: mergedVisible,
        [`${prefixCls}-border-left`]: restProps.type === 'primary'
    });
    return (<ButtonGroup>
            <Button disabled={disabled} onClick={onClick} {...restProps}>
                {children}
            </Button>
            <Dropdown disabled={disabled} placement={placement} trigger={trigger} overlay={overlay} overlayClassName={overlayClassName} overlayStyle={overlayStyle} getPopupContainer={getPopupContainer} visible={mergedVisible} onVisibleChange={handleVisibleChange}>
                <Button disabled={disabled} className={arrowCls} 
    // aucdIcon span元素高度和svg不一致 TODO
    icon={<OutlinedDown width={16} height={16} style={{ height: 16 }}/>} {...restProps}/>
            </Dropdown>
        </ButtonGroup>);
};
export default DropdownButton;
